import { render, staticRenderFns } from "./createProducts.vue?vue&type=template&id=30d991ca&"
import script from "./createProducts.vue?vue&type=script&lang=js&"
export * from "./createProducts.vue?vue&type=script&lang=js&"
import style0 from "./createProducts.vue?vue&type=style&index=0&id=30d991ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports